module.exports = "<img *ngIf=\"subProduct\"  class=\"env-image canvas-img\" [style.z-index]=\"zIndex\" [style.width]=\"width\" [style.height]=\"height\" [style.margin-left]=\"marginLeft\" style=\"opacity: 0\" />\r\n<img class=\"hidden-img env-image\" [style.z-index]=\"zIndex\" [style.width]=\"width\" [style.height]=\"height\" [style.margin-left]=\"marginLeft\" style=\"opacity: 0\" [src]=\"getSubProductImageSrc()\" />"


//////////////////
// WEBPACK FOOTER
// ./src/app/canvas/subproduct-image.component.html
// module id = 548
// module chunks = 1